import type { MediaResolution, MediaTypes } from './generic'
import type { FormattedPriceSettings } from './priceSettings'
import type { PurchaseInfo } from './purchaseInfo'

export const EventStatus = {
  LIVE: 'LIVE',
  SOON: 'SOON',
  LIVE_SOON: 'LIVE_SOON',
  ENDED: 'ENDED',
} as const
export type EventStatus = (typeof EventStatus)[keyof typeof EventStatus]

export const LiveEventsSortBy = {
  START_TIME: 'startTime',
  UPDATED_TIME: 'updatedTime',
} as const
export type LiveEventsSortBy =
  (typeof LiveEventsSortBy)[keyof typeof LiveEventsSortBy]

export const LiveEventsSortOrder = {
  ASC: 'asc',
  DESC: 'desc',
} as const
export type LiveEventsSortOrder =
  (typeof LiveEventsSortOrder)[keyof typeof LiveEventsSortOrder]

export interface LiveEvent {
  id: number
  externalId?: string
  name?: string
  description?: string
  ageRatings?: string
  free?: boolean
  status: EventStatus
  startTime?: string
  endTime?: string
  updated?: string
  locked?: boolean
  verticalPosterUrl?: string
  videoPosterUrl?: string
  videoVerticalPosterUrl?: string
  bannerPosterUrl?: string
  priceSettings?: FormattedPriceSettings[]
  purchaseInfo?: PurchaseInfo
  isLive?: boolean
  duration?: string
  formattedStartTime?: string
  rented: boolean
  recordAvailableFromTime?: string
  recordAvailableFromTimeMS?: number
  recorded?: boolean
  liveRewind?: boolean
  recordAvailableToTime?: string
  resolution?: MediaResolution
  dolbyAtmosAvailable?: boolean
  contentType?: MediaTypes
}
export interface GetLiveEventsParams {
  /** Omitted for a `collectionId` listing, which the backend never narrows by status. */
  status?: EventStatus
  page: number
  count?: number
  sortOrder?: LiveEventsSortOrder
  sortBy?: LiveEventsSortBy
  ids?: string
  collectionId?: string
  title?: string
  free?: string
}

type TPurchasedLiveEventsMyList = 'myList'
export interface GetPurchasedLiveEventsParams {
  page?: number
  count?: number
  sortBy?: LiveEventsSortBy
  sortOrder?: LiveEventsSortOrder
  // It can be any string, for wbs it doesn't matter
  myList?: TPurchasedLiveEventsMyList
}
